import { render, staticRenderFns } from "./ResourcesAdmin.vue?vue&type=template&id=3c82fa9b"
import script from "./ResourcesAdmin.vue?vue&type=script&lang=js"
export * from "./ResourcesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports